<template>
    <el-menu
        :default-active="activeIndex"
        class="el-menu-vertical"
        @open="handleOpen"
        @close="handleClose"
    >
        <template v-for="menu in menus">
            <template v-if="(getCurrentUser() && getCurrentUser().is_sa) || !menu.saOnly">
                <el-menu-item-group :key="menu.title" v-if="menu.children">
                    <template slot="title">{{menu.title}}</template>
                    <router-link
                        v-for="item in menu.children"
                        :key="item.index"
                        :to="item.path"
                    >
                        <el-menu-item :index="item.index">
                            <i :class="item.icon" />
                            <span slot="title">{{item.title}}</span>
                        </el-menu-item>
                    </router-link>
                </el-menu-item-group>
                <router-link :to="menu.path" :key="menu.title" v-else>
                    <el-menu-item :index="menu.index">
                        <i :class="menu.icon" />
                        <span slot="title">{{menu.title}}</span>
                    </el-menu-item>
                </router-link>
            </template>
        </template>
    </el-menu>
</template>

<script>
export default {
    name: "SideNavbar.vue",
    props: {
        current: {
            type: String,
            default: "/demand"
        }
    },
    data: function() {
        return {
            menus: [
                {
                    title: "最新订单",
                    path: "/order",
                    index: "order",
                    icon: "iconfont icon-xindingdan"
                },{
                    title: "新闻",
                    path: "/news",
                    index: "news",
                    icon: "iconfont icon-news"
                },                {
                    title: '科技成果',
                    path: "/achievement",
                    index: "achievement",
                    icon: "iconfont icon-jijian-zhiduhuibian-01"
                },{
                    title: '公司',
                    path: "/project",
                    index: "project",
                    icon: "iconfont icon-company"
                },
                {
                    title: "需求",
                    children: [
                        {
                            title: "分类",
                            path: "/demand/domain",
                            index: "demand-domain",
                            icon: "iconfont icon-leixing1"
                        }
                        // ,{
                        //     title: "需求",
                        //     path: "/demand",
                        //     index: "demand",
                        //     icon: "iconfont icon-kexuejishu-11"
                        // }
                        ,{
                            title: "申请",
                            path: "/demand/application",
                            index: "demand-application",
                            icon: "iconfont icon-shenqing"
                        },{
                            title: "订单",
                            path: "/demand/order",
                            index: "demand-order",
                            icon: "iconfont icon-zhangdancopy"
                        }
                    ]
                },{
                    title: "技术",
                    children: [
                        {
                            title: "分类",
                            path: "/technique/domain",
                            index: "technique-domain",
                            icon: "iconfont icon-leixing1"
                        },
                        // {
                        //     title: "技术",
                        //     path: "/technique",
                        //     index: "technique",
                        //     icon: "iconfont icon-kexuejishu-7"
                        // },
                        {
                            title: "订单",
                            path: "/technique/order",
                            index: "technique-order",
                            icon: "iconfont icon-zhangdancopy"
                        }
                    ]
                },{
                    title: "专家",
                    children: [
                        {
                            title: "分类",
                            path: "/specialist/domain",
                            index: "specialist-domain",
                            icon: "iconfont icon-leixing1"
                        },
                        {
                            title: "专家",
                            path: "/specialist",
                            index: "specialist",
                            icon: "iconfont icon-professor"
                        },
                        {
                            title: "订单",
                            path: "/specialist/order",
                            index: "specialist-order",
                            icon: "iconfont icon-zhangdancopy"
                        }
                    ]
                },{
                    title: "系统",
                    saOnly:true,
                    children: [
                        {
                            title: "管理员",
                            path: "/sa/admin",
                            index: "sys-user",
                            icon: "iconfont icon-users"
                        }
                    ]
                }
            ]
        };
    },
    computed: {
        activeIndex() {
            let result = "demand";
            this.menus.forEach(menu => {
                if(menu.children){
                    menu.children.forEach(item => {
                        if (item.path === this.current) {
                            result = item.index;
                            return;
                        }
                    });
                }else{
                    if (menu.path === this.current) {
                        result = menu.index;
                        return;
                    }
                }
            });
            return result;
        }
    },
    methods: {
        handleOpen(key, keyPath) {
            // eslint-disable-next-line no-console
            console.log(key, keyPath);
        },
        handleClose(key, keyPath) {
            // eslint-disable-next-line no-console
            console.log(key, keyPath);
        }
    }
};
</script>

<style>
.el-menu {
    margin:15px 0;
    text-align: left;
    border-right: none !important;
    z-index: 0;
}

.el-menu a {
    text-decoration: none;
}
.iconfont{
    display: inline-block;
    margin-right:8px;
    font-size:18px;
}
</style>